import React from 'react';

import states from '~/misc/states';

export const locationToString = (address) => {
  if (!address || (!address.city && !address.state)) {
    return 'Anywhere';
  }

  if (!address.city) {
    return states[address.state] || address.state;
  }

  if (!address.state) {
    return address.name;
  }

  return `${address.city}, ${address.state}`;
};


const LocationName = ({address, className}) => {
  if (!address || (!address.city && !address.state)) {
    return (
      <span className={className}>
        <span >Anywhere</span>
      </span>
    );
  }

  if (!address.city) {
    return (
      <span className={className}>
        {states[address.state] || address.state}
      </span>
    );
  }

  return (
    <span className={className}>
      <span >
        {address.city}
      </span>
      {', '}
      <span >
        {address.state}
      </span>
    </span>
  );
};

export default LocationName;



// WEBPACK FOOTER //
// ./src/components/search/LocationName/index.js